<template>
  <div>
    <Header></Header>
    <div class="ui container">
      <div v-if="this.loading">
        <div class="ui active inverted dimmer">
          <div class="ui text loader">Loading</div>
        </div>
        <p></p>
      </div>
      <table v-else ref="logsTable" id="example" class="ui celled table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Question</th>
            <th>Status</th>
            <th>Answer</th>
            <th>Asked On</th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr v-bind:key="key" v-for="(log, key) in this.logs">
            <td>{{ log.Name }}</td>
            <td>{{ log.Email }}</td>
            <td>
              <div class="table-text">{{ log.Q }}</div>
            </td>
            <td class="negative" v-if="log.Status == 0">
              <i class="icon close"></i> Unanswered
            </td>
            <td class="positive" v-if="log.Status == 1">
              <i class="icon checkmark"></i>Agent
            </td>
            <td class="positive" v-if="log.Status == 2">
              <i class="icon checkmark"></i>Auto
            </td>
            <td>
              <div class="table-text">{{ log.QA }}</div>
            </td>
            <td>{{ log.dateAsk }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "../components/Header";
import { async } from "q";
const dt = null;

export default {
  name: "log",
  components: { Header },
  data() {
    return { logs: [], loading: true };
  },
  methods: {
    async getRecords() {
      let response = await this.axios.post(
        this.$store.state.apiUrl + "Read/questions.php",
        {
          token: localStorage.getItem("token")
        }
      );
      this.logs = response.data.data;
      this.loading = false;
    }
  },
  beforeMount() {
    this.getRecords();
  },
  mounted() {
    this.dt = $(this.$refs.logsTable).DataTable();
  },
  watch: {
    logs(val) {
      this.dt.destroy();
      this.$nextTick(() => {
        this.dt = $(this.$refs.logsTable).DataTable();
      });
    }
  }
};
</script>

<style>
.table-text {
  white-space: nowrap;
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media only screen and (min-width: 1200px) {
  .ui.container.log {
    margin-left: auto !important;
    max-width: 900px !important;
    margin-right: auto !important;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 992px) {
  .ui.container {
    max-width: 1150px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Log.vue